/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { createPromiseRequest } from '../../../api/util/createPromiseRequest';
import { hasAccessToken } from '../../../../../utils/token';

export const listPsqlCustomerAreas = ({ customerName } = {}) => {
	const url = `/${  ['rel', 'customers','areas', customerName].filter(v => v && v !== 'Aegion').join('/')}`;

	if (hasAccessToken()) {
		const fetch = createPromiseRequest({
			url,
      aip: 'admin',
			method: 'GET',
		});

		return fetch();
	}
	return Promise.reject(new Error('Missing token'));
};
